export const LicensePlateMixin = {
    methods: {
        checkLicensePlate: async function (plate, country) {
            return new Promise(function (resolve) {
                fetch(
                    '/' +
                    this.$language +
                    '/backend/validate/license-plate/' +
                    encodeURIComponent(plate) +
                    '/' +
                    country
                )
                    .then((result) => result.json())
                    .then((result) => {
                        resolve(result.isValid);
                    });
            });
        },
    },
};

export const language = document.documentElement.lang.substring(0, 2);

export default function(app) {
    app.config.globalProperties.$language = language;

    const currentDate = new Date(),
        currentDay = currentDate.getDate(),
        currentMonth = currentDate.getMonth() + 1,
        currentYear = currentDate.getFullYear();

    app.config.globalProperties.$datePickerOptions = {
        minDate:
            currentYear +
            '-' +
            (currentMonth > 9 ? '' : '0') +
            currentMonth +
            '-' +
            (currentDay > 9 ? '' : '0') +
            currentDay,
        format: 'DD.MM.YYYY',
        locale: app.config.globalProperties.$language,
        useCurrent: false,
    };
};
